import React from 'react';
import clsx from 'clsx';

import CalendarWidget from 'components/FormFields/CalendarWidget';

/**
 * A component that renders a date input.
 *
 * @param {object} props - The component props.
 * @param {string} [props.inputClasses] - Additional CSS classes for the input.
 * @param {string} [props.wrapperClasses] - Additional CSS classes for the component wrapper div.
 * @param {string} [props.labelClasses] - Additional CSS classes for the label.
 * @param {string} props.name - The name of the input, used for id and form submission.
 * @param {string} props.label - The text to display for the label.
 * @param {string} [props.response] - The initial value of the input in the format MM/DD/YYYY.
 * @param {function(string): void} props.handleSubmit - The function to call when the date is changed.
 */
export const DateSelect = ({
  inputClasses,
  wrapperClasses,
  labelClasses,
  name,
  label,
  response,
  handleSubmit,
}) => {
  return (
    <div
      className={clsx(wrapperClasses, 'custom-form-field--date-select')}
    >
      <label
        className={labelClasses}
        htmlFor={`custom-form-field-${name}`}
      >
        {label}
      </label>
      <CalendarWidget
        id={`custom-form-field-${name}`}
        name={label}
        value={response}
        setDate={(value) => handleSubmit(value)}
        className={inputClasses}
        nNextYears={10}
        nPastYears={1}
        showLabel={false}
      />
    </div>
  );
};
